"use client";
import { createPlayer } from "../../player/create-player.js";
import { videoFeatures } from "@videojs/core/dom";
//#region src/presets/video/player.ts
/** Preconfigured player with the standard video features. */
const { Player: VideoPlayer, usePlayer } = createPlayer({
	features: videoFeatures,
	displayName: "VideoPlayer"
});
//#endregion
export { VideoPlayer, usePlayer };

//# sourceMappingURL=player.js.map